import React, { useState, useEffect } from 'react';
import { getAllSupporters } from '../../services/conferenceService';
import { useScrollAnimation } from '../../utils/scrollAnimations';
import './SupportersLogos.css';

const SupportersLogos = ({ variant = 'main' }) => {
  const [supporters, setSupporters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.2 });

  useEffect(() => {
    loadSupporters();
  }, []);

  const loadSupporters = async () => {
    try {
      const data = await getAllSupporters();
      setSupporters(data);
    } catch (error) {
      console.error('Error loading supporters:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null; // Don't show loading spinner for logos, just hide until loaded
  }

  if (supporters.length === 0) {
    return null; // Don't show section if no supporters
  }

  // Separate by tier/level if needed
  const featuredSupporters = supporters.filter(s => s.featured || s.tier === 'platinum' || s.tier === 'gold');
  const regularSupporters = supporters.filter(s => !featuredSupporters.includes(s));

  const renderSupporter = (supporter) => {
    const logoContent = supporter.logo_url ? (
      <img
        src={supporter.logo_url}
        alt={supporter.name || 'Supporter Logo'}
        className="supporter-logo"
      />
    ) : (
      <span className="supporter-name">{supporter.name}</span>
    );

    if (supporter.website_url) {
      return (
        <a
          href={supporter.website_url}
          target="_blank"
          rel="noopener noreferrer"
          className="supporter-link"
        >
          {logoContent}
        </a>
      );
    }

    return logoContent;
  };

  return (
    <section 
      ref={sectionRef}
      className={`supporters-logos-section ${variant} ${isVisible ? 'visible' : ''}`}
    >
      <div className="supporters-container">
        <h2 className="supporters-title">Our Conference Supporters</h2>
        
        {featuredSupporters.length > 0 && (
          <div className="supporters-tier featured">
            {featuredSupporters.map((supporter) => (
              <div key={supporter.id} className="supporter-logo-item">
                {renderSupporter(supporter)}
              </div>
            ))}
          </div>
        )}

        {regularSupporters.length > 0 && (
          <div className="supporters-tier regular">
            {regularSupporters.map((supporter) => (
              <div key={supporter.id} className="supporter-logo-item">
                {renderSupporter(supporter)}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default SupportersLogos;
